import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  
  console.log("rest", rest);
  console.log("Private route authenitcated: ", rest.authenticated);
  return (
    <Route
      {...rest}
      render={props =>
        rest.authenticated ? (
          <Component {...rest} {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
  }

export default PrivateRoute;
